import { useEffect, useCallback, useRef, useState } from "react";
import "./CustomerPaymentLedger.css";
import { Select, DatePicker, Form, Table, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { getAllCompany } from "../../redux/actions/companyAccess";
import { getAllScmBrand } from "../../redux/actions/scmBrand.action";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getCustomerPaymentReport } from "../../redux/actions/customerPayment.action";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import moment from "moment";
import { useParams } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { currencySymbol } from "../../utils/constants";

const { Option } = Select;
const dateFormatList = ["MM/DD/YYYY"];

const CustomerPaymentLedgerAR = ({ token, userRights }) => {
  TabTitle("Customer Ledger")
  const userName = ReadCookie("name");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const focusInput = useRef(null);
  const tableRef = useRef(null);
  const [select, setSelect] = useState("All");
  const [loader, setLoader] = useState(false);
  const [customerList, setCutomerList] = useState([]);
  const [customerId, setCutomerId] = useState([]);
  const [excelData, setExcelData] = useState([])
  const {
    gender,
    region,
    companyAll,
    scmBrand,
    customerForms,
    getBussinessDashboardReducer,
    customerPayment,
  } = useSelector((state) => state);
  const menuId = userRights.col_menu_id;
  const [customer, setCustomer] = useState("All");
  const { submited } = useParams();



  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);
  let rbalance = 0;

  const onFinish = async (e) => {
    setLoader(true)
    await form.validateFields().then((values) => {
      dispatch(getCustomerPaymentReport(token, values)).then((res) => {

        let filterData = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id != "0";
        })

        let filterZeroId = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id == "0";
        })


        setCutomerId(filterZeroId)
        setCutomerList(filterData)
        setLoader(false);
        downloadExcelFileData(res?.payload?.data);
      })
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getAllCompany(token));
    dispatch(getAllScmBrand(token));
    dispatch(getCustomerType(token));
  }, [dispatch, menuId, token]);

  const handlePrint = () => {
    const css = '@page { margin-top: 25px; margin-bottom: 25px; margin-right: 17px}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Invoice#": v.invoice_header_no,
          "Invoice Date": moment(v.invoice_date).format("MM-DD-YYYY"),
          "PO Number": v.po_number,
          "Term": v.term_name,
          "Currency": currencySymbol,
          "Invoice Amount": v.invoice_amount,
          "Return": v.note_amount,
          "Payment": v.amount_paid,
          "Adjustment / Credit Apply": v.payment_adjustment,
          "Refund": v.refund_amount,
          "Credit Take": v.credituse,
          "CN Apply": v.credit_note_apply,
          "CM Apply": v.credit_memo_apply,
          "Balance": v.balance,
          "R.Balance": v.running_balance,
          "Status": v.status,
          "Days": v.daysdiff,
          "Due Date": moment(v.due_date).format("MM-DD-YYYY"),
          "Gender": v.gender_name,
        };
      })
    )
  }


  const column = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Invoice#",
      dataIndex: "invoice_header_no",
      key: "invoice_header_no",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      render: (text, record) => {
        return moment(record.invoice_date).format("MM-DD-YYYY")
      }
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      width: 150
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
    },
    {
      title: "Invoice Amount",
      dataIndex: "invoice_amount",
      key: "invoice_amount",
      render: (text, record) => {
        return Number(record.invoice_amount).toFixed(2)
      }
    },
    {
      title: "Return",
      dataIndex: "note_amount",
      key: "note_amount",
      render: (text, record) => {
        return Number(record.note_amount).toFixed(2)
      }
    },
    {
      title: "Payment",
      dataIndex: "amount_paid",
      key: "amount_paid",
      render: (text, record) => {
        return Number(record.amount_paid).toFixed(2)
      }
    },
    {
      title: "Adjustment / Credit Apply",
      dataIndex: "payment_adjustment",
      key: "payment_adjustment",
      render: (text, record) => {
        return Number(record.payment_adjustment).toFixed(2)
      }
    },
    {
      title: "Refund",
      dataIndex: "refund_amount",
      key: "refund_amount",
      render: (text, record) => {
        return Number(record.refund_amount).toFixed(2)
      }
    },
    {
      title: "Credit Take",
      dataIndex: "credituse",
      key: "credituse",
      render: (text, record) => {
        return Number(record.credituse).toFixed(2)
      }
    },
    {
      title: "CN Apply",
      dataIndex: "credit_note_apply",
      key: "credit_note_apply",
      render: (text, record) => {
        return Number(record.credit_note_apply).toFixed(2)
      }
    },
    {
      title: "CM Apply",
      dataIndex: "credit_memo_apply",
      key: "credit_memo_apply",
      render: (text, record) => {
        return Number(record.credit_memo_apply).toFixed(2)
      }
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      render: (text, record) => {
        return Number(record.balance).toFixed(2)
      }
    },
    {
      title: "R.Balance",
      dataIndex: "r_balance",
      key: "r_balance",
      render: (text, record) => {
        return Number(record.r_balance).toFixed(2)
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render(text, record) {
        return {
          props: {
            style: { color: text === "Paid" || text === "Excess Paid" ? "green" : "red" }
          },
          children: <div>{text}</div>
        };
      }
    },
    {
      title: "Days",
      dataIndex: "daysdiff",
      key: "daysdiff",
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (text, record) => {
        return moment(record.due_date).format("MM-DD-YYYY")
      }
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
    },
  ];

  const total_invoice_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.invoice_amount), 0)
  const total_note_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.note_amount), 0)
  const total_amount_paid = customerList.reduce((acc, item, index) => acc + parseFloat(item.amount_paid), 0)
  const total_adjustment = customerList.reduce((acc, item, index) => acc + parseFloat(item.payment_adjustment), 0)
  const total_Adj_Amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.adj_amount), 0)
  const total_refund_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.refund_amount), 0)
  const total_credit_use = customerList.reduce((acc, item, index) => acc + parseFloat(item.credituse), 0)
  const total_credit_note_apply = customerList.reduce((acc, item, index) => acc + parseFloat(item.credit_note_apply), 0)
  const total_memo_apply = customerList.reduce((acc, item, index) => acc + parseFloat(item.credit_memo_apply), 0)
  const total_balance = customerList.reduce((acc, item, index) => acc + parseFloat(item.balance), 0)
  const total_running_balance = customerList.reduce((acc, item, index) => acc + parseFloat(item.running_balance), 0)


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="report-wrapper-main header_class business_class ">
            <div className="row justify-content-between pb-2 ledger_print_ar">
              <div className="col-3 d-flex align-items-start  box-space">
                <div className="logobrand">
                  <img id="ImgLogo" alt="logo" src={logo} />
                </div>
              </div>

              <div className="col-4 box-space right-content-header text-right pb-0">
                <div className=" d-flex justify-content-end">
                  <div className=" d-flex printing_class mr-8">
                    <div className="print_icon printing_class">
                      <i
                        onClick={handlePrint}
                        id="Image1"
                        title="Print"
                        alt="Print"
                        src={btnPrint}
                        className="fa-solid fa-print"
                      ></i>
                    </div>
                    <div className="print_icon printing_class" >
                      <CSVLink
                        filename={`Customer-Payment-ledger-${customerPayment?.payload?.data[0]?.customer_name}.csv`}
                        data={excelData}
                        onClick={() => {
                        }}
                      >
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={xlsx}


                          style={{ borderWidth: "0px", height: "14px" }}
                        />
                      </CSVLink>
                    </div>
                  </div>
                  <span style={{ fontWeight: "bolder" }}>
                    Customer Payment Ledger AR
                    <br />

                    <div>
                      Rpt # 489
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            {/* Filters Table */}
            <div className="row ledger_print_ar">
              <div className="col business_header">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                  <div className="main_form row">

                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          From:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="from_date"
                            initialValue={moment("2010-01-01", "YYYY-MM-DD")}
                          >
                            <DatePicker
                              size="small"
                              defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}

                            />
                          </Form.Item>
                        </div>
                      </div>

                    </div>
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          To:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="to_date"
                            initialValue={moment().endOf('year')}
                          >
                            <DatePicker
                              size="small"
                              defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}

                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main_form row">

                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Customer:</label>
                        <div className=" w-100">
                          <Form.Item
                            name="customer_id"
                            rules={[
                              {
                                required: true,
                                message: "Customer is Required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              allowClear
                              optionFilterProp="children"
                              className={"select_Inputs"}
                              loading={customerForms.loading}

                              size="small"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                              ref={focusInput}
                              value={customer}
                            >
                              {customerForms?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.customer_id}
                                    value={item.customer_id}
                                  >
                                    {" "}
                                    {`${item.customer_code} ${item.customer_name}`}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Status:</label>
                        <div className=" w-100">
                          <Form.Item
                            className=" w-100"
                            name="status"
                            initialValue={"All"}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"

                              className="select_Inputs"

                              defaultValue={
                                submited ? form.getFieldValue().status : "All"
                              }
                              size="small"
                            >
                              <Option key={"All"} value={"All"}>
                                All
                              </Option>
                              <Option key={"P"} value={"P"}>
                                Paid
                              </Option>
                              <Option key={"U"} value={"U"}>
                                Unpaid
                              </Option>
                              {/* <Option key={"E"} value={"E"}>
                                Excess Paid
                              </Option> */}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div>
                        <Button
                          htmlType="submit"
                          type="primary"
                          className="submit-btn-btm "
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
            {/* Render Data Table */}
          </div>
          <div className="table_content customer_ledger_table_content ledger_print omsTable "

            style={{ maxWidth: '1460px' }}
          >
            <div className="">
              {customerPayment ? (
                customerPayment?.payload?.data.length > 0 ? (
                  (
                    <div className="data_Table ledger_print_ar">
                      <div >
                        <div

                          style={{ margin: "0 auto", paddingTop: "10px" }}
                        >
                          <table id="Table1" cellPadding="3" cellSpacing="0" align="center" className="tablestyleControls" style={{ fontSize: "10px" }}>
                            <tbody>
                              <tr>
                                <td className="font_weight">
                                  Name :
                                </td>
                                <td style={{ width: "106px" }} colSpan={2}>
                                  <b>
                                    {customerPayment?.payload?.data[0].customer_name}
                                  </b>
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td className="font_weight">
                                  Address :
                                </td>
                                <td colSpan={2}>
                                  <b>
                                    {customerPayment?.payload?.data[0].address_1}
                                  </b>
                                </td>
                                <td></td>
                                <td className="font_weight">
                                  Balance :
                                </td>
                                <td colSpan={2}>
                                  <b className="font_weight">
                                    {currencySymbol}{numeral(total_balance).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                              {/* <tr>
                                <td className="no-border-btm font_weight" style={{ width: "70px" }}>
                                  City :
                                </td>
                                <td style={{ width: "263px" }}>
                                  <b>
                                    {customerPayment?.payload?.data[0].city_name}
                                  </b>
                                </td>
                                <td style={{ width: "126px" }} className="font_weight">
                                  State :
                                </td>
                                <td style={{ width: "119.6px" }} >
                                  <b>
                                    {customerPayment?.payload?.data[0].state_name}
                                  </b>
                                </td>
                              </tr> */}
                              <tr>
                                <td className="font_weight">
                                  City :
                                </td>
                                <td>
                                  <b>
                                    {customerPayment?.payload?.data[0].city_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  State :
                                </td>
                                <td>
                                  <b>
                                    {customerPayment?.payload?.data[0].state_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Other Credit :
                                </td>
                                <td>
                                  <b className="font_weight">
                                    {currencySymbol}{numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="font_weight">
                                  Country :
                                </td>
                                <td>
                                  <b>
                                    {customerPayment?.payload?.data[0].country_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Zip Code :
                                </td>
                                <td>
                                  <b>
                                    {customerPayment?.payload?.data[0].zip_code}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Unapplied Amount :
                                </td>
                                <td >
                                  <b className="font_weight">
                                    {currencySymbol}{numeral(customerId && customerId[0]?.unapplied_amount).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                            </tbody >
                          </table >
                        </div>
                      </div>
                    </div>
                  )

                ) : <></>) : <></>}
              <Table
                className="
                
                test04 mt-3 sales_report_res_table_intransit ledger_print omsTable"
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName='abc'
                dataSource={customerList && customerList}
                columns={column}
                loading={customerPayment.loading}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 100,
                  pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                }}
                summary={(pageData) => {
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={3}>Other Credit : {numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell colSpan={2}>Unapplied Amount : {numeral(customerId && customerId[0]?.unapplied_amount).format("0,00,0")}</Table.Summary.Cell>
                        <Table.Summary.Cell>

                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_invoice_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_note_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_memo_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_amount_paid.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_adjustment.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_refund_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_credit_use.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_credit_note_apply.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_memo_apply.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_balance.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_running_balance.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerPaymentLedgerAR;
